export enum BackgroundTypeEnum {
  OUTFIT = 0,
  MIX_AND_MATCH = 1,
}
